/** @format */
import { Injectable } from '@angular/core';
import { EntityState, EntityStore, QueryEntity, StoreConfig } from '@datorama/akita';
import { NgEntityServiceConfig } from '@datorama/akita-ng-entity-service';
import { OtmId, StoredDocumentSignatureInfo } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntityService } from './entity.service';

const CONFIG = {
    ENDPOINTS: {
        backend: '/seppo/api',
        downloadElectronicSignatureStoredDocument(id: OtmId): string {
            return `${this.backend}/electronic-signature-stored-document/${id}/presigned-download`;
        },
    },
};

@Injectable({
    providedIn: 'root',
})
@NgEntityServiceConfig({
    baseUrl: CONFIG.ENDPOINTS.backend,
})
export class ElectronicSignatureStoredDocumentEntityService extends EntityService<ElectronicSignatureStoredDocumentState> {
    constructor() {
        super(ElectronicSignatureStoredDocumentStore, ElectronicSignatureStoredDocumentQuery);
    }

    getElectronicSignatureStoredDocumentDownloadUrl(signatureRequestId: string): Observable<string> {
        return this.getHttp()
            .get<StoredDocumentSignatureInfo>(CONFIG.ENDPOINTS.downloadElectronicSignatureStoredDocument(signatureRequestId))
            .pipe(map((response: StoredDocumentSignatureInfo) => response.urlPath));
    }
}
type ElectronicSignatureStoredDocumentState = EntityState<StoredDocumentSignatureInfo, OtmId>;

@StoreConfig({ name: 'electronic-signature-stored-document' })
class ElectronicSignatureStoredDocumentStore extends EntityStore<ElectronicSignatureStoredDocumentState> {}

class ElectronicSignatureStoredDocumentQuery extends QueryEntity<ElectronicSignatureStoredDocumentState> {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(store: ElectronicSignatureStoredDocumentStore) {
        super(store);
    }
}
